/**
 * Supabase Edge may return HTML or plain text when a function is missing (404) — `response.json()` then throws.
 * Use this after `await response.text()` to get a stable error for the interview UI.
 */
export function parseInterviewEdgeJson(text: string): { ok: true; data: unknown } | { ok: false } {
  const t = text.trim();
  if (!t) return { ok: true, data: {} };
  try {
    return { ok: true, data: JSON.parse(t) };
  } catch {
    return { ok: false };
  }
}

export function interviewEdgeUndeployedMessage(status: number): string {
  return `The interview API did not return JSON (HTTP ${status}). The Edge function may not be deployed. From the B2B repo run: supabase functions deploy ggj_b2b_ai_interview_public --project-ref YOUR_PROJECT_REF`;
}
